import { useAuthContext } from '@/context/AuthContext';
import { useState } from 'react';
import errorToText from '@/utils/errorToText';
import {userManager} from '@/components/authentication/keycloak.js';
import {useAppSelector} from '@/store/hooks.js';

const useAddRetributionModel = () => {

    const [response, setResponse] = useState(null);
    const authUser = useAppSelector((state) => state.auth.currentUser);
    const addRetributionModel = async (upToFiveConsultants, upToTenConsultants, moreThanTenConsultants) => {

        const user = await userManager.getUser();
        try {
            const response = await fetch(window.ENV.BACKEND_URL+'/api/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.access_token}`
                },
                body: JSON.stringify({
                    query: `
                    mutation addRetributionModel {
                        addRetributionModel(
                            newRetributionModel: {
                              upToFiveConsultants: ${upToFiveConsultants}, 
                              upToTenConsultants: ${upToTenConsultants}, 
                              moreThanTenConsultants: ${moreThanTenConsultants}, 
                              companyUuid: "${authUser.company.uuid}"
                            }
                          ) {
                            uuid
                            upToTenConsultants
                            upToFiveConsultants
                            moreThanTenConsultants
                        }
                    }
                    `
                })
            });


            if (!response.ok) {
                const errMessage = errorToText(response);
                throw new Error(errMessage);
            }

            const data = await response.json();
            if (data.errors) {
                const errMessage = data.errors[0].message;
                throw new Error(errMessage);
            }

            setResponse(data.data.addRetributionModel);

            return { data: data.data.addRetributionModel, error: null };
        } catch (err) {
            return { data: null, error: err.message };
        }
    };

    return { addRetributionModel, uuidResponnse: response };
};

export default useAddRetributionModel;
